import React, { useCallback, useRef } from 'react';

import Button from '@material-ui/core/Button';
import VideoOffIcon from '../../../icons/VideoOffIcon';
import VideoOnIcon from '../../../icons/VideoOnIcon';

import useDevices from '../../../hooks/useDevices/useDevices';
import useLocalVideoToggle from '../../../hooks/useLocalVideoToggle/useLocalVideoToggle';
import { RequestParameter } from '../../../utils/model';

export default function ToggleVideoButton(props: { disabled?: boolean; className?: string }) {
  const [isVideoEnabled, toggleVideoEnabled] = useLocalVideoToggle();
  const lastClickTimeRef = useRef(0);
  const { hasVideoInputDevices } = useDevices();
  const rp = RequestParameter.getInstance();

  const toggleVideo = useCallback(() => {
    if (Date.now() - lastClickTimeRef.current > 500) {
      lastClickTimeRef.current = Date.now();
      toggleVideoEnabled();
    }
  }, [toggleVideoEnabled]);

  return (
    <Button
      id="btnVideo"
      className={props.className}
      onClick={toggleVideo}
      disabled={!hasVideoInputDevices || props.disabled || rp.getVideo().toLocaleLowerCase() !== 'yes'}
      startIcon={isVideoEnabled ? <VideoOnIcon /> : <VideoOffIcon />}
      title={!hasVideoInputDevices ? 'No Video' : isVideoEnabled ? 'Stop Video' : 'Start Video'}
    >
      {!hasVideoInputDevices ? 'No Video' : isVideoEnabled ? 'Stop Video' : 'Start Video'}
    </Button>
    // <Button
    //     className={props.className}
    //     onClick={toggleVideo}
    //     disabled={false}
    //     startIcon={isVideoEnabled ? <VideoOnIcon /> : <VideoOffIcon />}
    //   >
    //     {!hasVideoInputDevices ? 'No Video' : isVideoEnabled ? 'Stop Video' : 'Start Video'}
    //   </Button>
  );
}
